import Pqp from "../../../../3x1010/Pqp.js";
import Maze from "../../../maze/Maze.js";
import PermissiveFov from "../../../utils/permissiveFov/PermissiveFov.js";
import Control from "../../controllers/Control.js";
import MobControl from "../../controllers/MobControl.js";
import Decision from "./decisions/Decision.js";
import MoveTo from "./decisions/MoveTo.js";
import RandomMove from "./decisions/RandomMove.js";
import StayPut from "./decisions/StayPut.js";
import TrackHero from "./decisions/TrackHero.js";


export default class BasicAI {
	constructor(model, tileMap) {
		this.model = model;
		this.tileMap = tileMap;
		this.mob = null;
		this.control = null;
		this.currentDecision = null;
		this.decisions = new Array();
		this.history = new Array();
		this.pfov = null;
		this.heroTargetted = false;
		this.heroTracked = false;
		this._asleep = true;
	}
	attachTo(mob) {
		this.mob = mob;
		mob.setAI(this);
	}

	isAsleep() {
		return this.asleep;
	}

	init() {
		this.pfov = new PermissiveFov(this.model.cols, this.model.rows, this.isCellTransparent.bind(this));
		this.control = new MobControl(this.controlEventsHandler.bind(this))
		this.control.init();
		this.control.enable(true);
		this.control.attachTo(this.mob);
	}

	controlEventsHandler(e) {
		if (e.type === Control.EVENT_CHANGED_STATUS) {
			e.data.mob.setAnimation(e.data.status);
		}
		if (e.type === Control.EVENT_MOVE) {
			this.tileMap.moveMobTo(e.data.mob, e.data.x, e.data.y, false);
		}


	}

	isCellTransparent(row, col) {
		return this.tileMap.isCellTransparent(row, col, this.mob);
	}


	think() {
		if (this.mob.isInView()) {
			/*if (this.isAsleep()) {
				this.asleep = false;*/
			//console.log("scelgo!")
			this.choseWhatToDo();
			this.executeCurrentDecision();
			//}
		}
	}

	choseWhatToDo() {
		let initer = this.getIniter(this.decisionsEventsHandler.bind(this));
		let intention = BasicAI.DECISIONS[Pqp.rnd(BasicAI.DECISIONS.length - 1)];
		if (this.mob.isInvulnerable()) {
			intention = BasicAI.DECISION_RANDOM_MOVE;
		}

		if (intention === BasicAI.DECISION_STAYPUT) {
			this.add(new StayPut(initer));
		} else if (intention === BasicAI.DECISION_RANDOM_MOVE) {
			let moveFor = Pqp.rnd(4, 1);
			for (let x = 0; x < moveFor; x++) {
				this.add(new RandomMove(initer));
			}
			this.add(new StayPut(initer));
		}

	}


	getIniter(callback) {
		let initer = {
			mob: this.mob,
			control: this.control,
			model: this.model,
			tileMap: this.tileMap,
			callback: callback
		}
		return initer;
	}

	add(decision) {
		this.decisions.push(decision);
		this.history.push(decision.constructor.name);
		if (this.history.length > 10) {
			this.history.shift();
		}

	}

	decisionsEventsHandler(e) {
		/*if (e.type === Decision.EVENT_TO_REMOVE) {
			this.removeDecisionFromProgress(e);
			return
		}*/


		//console.log(e.type, this.heroTargetted)
		if (e.type === Decision.EVENT_IN_PROGRESS) {
			
			this.addDecisionInProgress(e);
			return
		}

		if (this.heroTargetted) {
			return;
		}

		
		if (e.type === Decision.EVENT_ACCOMPLISHED) {
			if (this.decisions.length === 0) {
				if (this.mob.isInView()) {
					this.think();
					//	} else {
					//	this.asleep = true;
				}
			} else {
				this.executeCurrentDecision(e.data);
			}
		}
	}

	executeCurrentDecision(payload = null) {
		this.currentDecision = this.decisions.shift();
		//console.log(this.currentDecision)
		this.currentDecision.execute(payload);
	}

	lookForHero() {
		// Controlla se l'eroe è nel campo visivo
		this.pfov.compute(this.mob.cell.col, this.mob.cell.row, this.mob.radius, this.scanCellForHero.bind(this, this.mob));
		if (!this.heroTargetted) {
			if (this.mob.isWarned()) {
				this.mob.warnCount++;
				if (this.mob.warnCount == this.mob.timeWarns[0]) {
					// Ancora allertato
					this.mob.warned = 1;
				}
				if (this.mob.warnCount == this.mob.timeWarns[1]) {
					// Non più allertato
					this.mob.warned = 0;
					this.mob.warnCount = 0;
				}
			}
			// Se l'eroe era nel campo visivo e ora non lo è più
			if (this.heroTracked) {
				//console.log("--- SPARITO ---")
				//console.log(this.mob.warnCount)
				//console.log(this.decisions.slice())
				let lastKnownPosition = null;
				if (this.decisions.length >= 2) {
					lastKnownPosition = this.decisions[this.decisions.length - 2].endCell;
				}
				this.heroTracked = false;
				this.control.stop();
				this.stopAllDecisions();
				// Ferma 
				clearTimeout(this.idstop)
				if (this.mob.getQI() === BasicAI.QI_LOW) {
					// Gli slime rimangono li 
					this.idstop = setTimeout(this.think.bind(this), 30);
				} else {
					// L'orco va all'ultima posizione conosciuta
					if (!lastKnownPosition) {
						this.idstop = setTimeout(this.think.bind(this), 30);
					} else {
						this.idstop = setTimeout(this.gotoCell.bind(this, lastKnownPosition), 30);
					}

				}
				//this.think()
				//requestAnimationFrame(this.think.bind(this))
				// eventualmente inserire qui il concerned/vai verso l'ultima posizione conosciuta
			}

		}

	}

	stopAllDecisions() {
		if (this.currentDecision) {
			//console.log(this.decisions.length)
			//console.log(this.currentDecision)
			//this.removeDecisionFromProgress(this.currentDecision);
			this.currentDecision.destroy();
			this.currentDecision = null;
		}
		this.decisions = new Array();
	}


	scanCellForHero(mob, row, col) {

		if (!mob.isWarned()) {
			if (mob.facing === Maze.DIR_N) {
				if (row > mob.cell.row) {
					return;
				}
			}
			if (mob.facing === Maze.DIR_E) {
				if (col < mob.cell.col) {
					return;
				}
			}

			if (mob.facing === Maze.DIR_S) {
				if (row < mob.cell.row) {
					return;
				}
			}
			if (mob.facing === Maze.DIR_W) {
				if (col > mob.cell.col) {
					return;
				}
			}
		}


		let cell = this.model.maze[row][col];
		let hero = this.tileMap.mobInCamera;
		if (cell.id === hero.cell.id) {
			if (!this.heroTargetted) {
				// L'eroe è nel campo visivo, rimuove ogni altra azione e stoppa il generarsi di altre azioni
				this.heroTargetted = true;
				this.heroTracked = true;
				mob.warned = 2;
				mob.warnCount = 0;

				this.decisions = new Array();
				this.trackHero(cell);
			}
		}
	}

	trackHero(cell) {
		// Trova la strada dal punto in cui si trova il mob a dove si trova l'eroe
		let o = this.tileMap.currentBoundingBox;
		let subset = this.model.getCellsSubsetMatrix(o.top, o.left, o.bottom, o.right);
		this.model.localPathFind(this.mob.cell, cell, subset, this.pathFound.bind(this));
	}
	pathFound(path) {
		// Ha trovato un path
		//console.log("----- PATH FOUND -----")
		// Aggiunge tutte le azioni per far muovere il mob verso l'eroe
		//console.log(path);

		for (let x = 0; x < path.length; x++) {
			/*initer = {
				cell: path[x],
				mob: this.mob,
				control: this.control,
				model: this.model,
				tileMap: this.tileMap,
				callback: this.huntHandler.bind(this)
			}*/
			let initer = this.getIniter(this.huntHandler.bind(this));
			initer.cell = path[x];

			this.add(new TrackHero(initer));
		}
		//let initer = this.getIniter(this.huntHandler.bind(this));
		let initer = this.getIniter(this.decisionsEventsHandler.bind(this));
		this.add(new StayPut(initer));
		// Esegue la prima azione dello stack
		this.executeCurrentDecision();
	}

	huntHandler(e) {
		/*if (e.type === Decision.EVENT_TO_REMOVE) {
			this.removeDecisionFromProgress(e);
			return
		}*/

		if (e.type === Decision.EVENT_IN_PROGRESS) {
			this.addDecisionInProgress(e);
			return
		}


		this.heroTargetted = false;
		if (e.type === TrackHero.EVENT_CANT_MOVE) {
			// Se qualcosa è andato storto, stoppa il mob ed eventualmente aspetta che l'hero sia sparito dalla vista
			this.control.stop();
			this.currentDecision.destroy();
			//console.log("---- BAD HUNT ----")
		} else {
			// Altrimenti aggiorna la route vero l'eroe!
			this.lookForHero();
			//console.log("---- GOOD HUNT ----")
		}
	}

	addDecisionInProgress(e) {
		this.tileMap.addDecisionInProgress(e.data);
	}
	/*removeDecisionFromProgress(e) {
		//this.tileMap.removeDecisionFromProgress(e.data);
	}*/

	get asleep() {
		return this._asleep;
	}
	set asleep(value) {
		//console.log(value)
		this._asleep = value;
	}

	gotoCell(cell) {
		let o = this.tileMap.currentBoundingBox;
		let subset = this.model.getCellsSubsetMatrix(o.top, o.left, o.bottom, o.right);
		this.model.localPathFind(this.mob.cell, cell, subset, this.pathToCellFound.bind(this));

	}

	pathToCellFound(path) {
		for (let x = 0; x < path.length; x++) {
			let initer = this.getIniter(this.decisionsEventsHandler.bind(this));
			initer.endCell = path[x];
			this.add(new MoveTo(initer));
		}
		this.heroTargetted = false;		
		//let initer = this.getIniter(this.huntHandler.bind(this));
		let initer = this.getIniter(this.decisionsEventsHandler.bind(this));
		this.add(new StayPut(initer));
		//console.log(this.decisions.slice())
		// Esegue la prima azione dello stack
		this.executeCurrentDecision();
	}


}


BasicAI.DECISION_STAYPUT = "StayPut";
BasicAI.DECISION_RANDOM_MOVE = "RandomMove";
BasicAI.TRACK_HERO = "TrackHero";
BasicAI.CONCERNED = "Concerned";

BasicAI.DECISIONS = [
	BasicAI.DECISION_STAYPUT,
	BasicAI.DECISION_RANDOM_MOVE
];


BasicAI.QI_PLAYER = "qiplayer";
BasicAI.QI_NONE = "qinone";
BasicAI.QI_LOW = "qibasso";
BasicAI.QI_MEDIUM = "qimedium";
